/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inclusive_Spare_Butterfly_CryInputs */

const fr_inclusive_spare_butterfly_cry = /** @type {(inputs: Inclusive_Spare_Butterfly_CryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminer`)
};

/**

* @param {Inclusive_Spare_Butterfly_CryInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const inclusive_spare_butterfly_cry = /** @type {((inputs?: Inclusive_Spare_Butterfly_CryInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inclusive_Spare_Butterfly_CryInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_inclusive_spare_butterfly_cry(inputs)
});